import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AbstractFlatWidget } from "src/app/shared/components/flat/abstract-flat-widget";
import { ChannelAddress, CurrentData, Utils } from "src/app/shared/shared";

@Component({
    selector: "autarchyWidget",
    templateUrl: "./flat.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FlatComponent extends AbstractFlatWidget {
    protected autarchyValue: number | null = null;
    /**
     * Ob diese Edge einen echten Netz-Zähler hat - ohne Zähler ist Autarkie
     * nicht sinnvoll berechenbar. Siehe [[project_excello_teuschnitz_pv_monitoring]].
     */
    protected hasGridMeter: boolean = true;

    protected override afterIsInitialized(): void {
        this.hasGridMeter = this.config
            ?.getComponentsImplementingNature("io.openems.edge.meter.api.ElectricityMeter")
            .some(c => c.isEnabled && this.config.isTypeGrid(c)) ?? true;
    }

    protected override onCurrentData(currentData: CurrentData) {
        this.autarchyValue = this.hasGridMeter
            ? Utils.calculateAutarchy(
                currentData.allComponents["_sum/GridBuyActiveEnergy"] / 1000,
                currentData.allComponents["_sum/ConsumptionActiveEnergy"] / 1000,
            )
            : null;
    }

    protected override getChannelAddresses(): ChannelAddress[] {
        return [
            new ChannelAddress("_sum", "GridBuyActiveEnergy"),
            new ChannelAddress("_sum", "ConsumptionActiveEnergy"),
        ];
    }
}
